<template>
  <div id="index" class="banlijianzhuxuke">
    <top :default-index="0"></top>
    <div class="banlijianzhuxukebody">
      <div class="left">
        <zhishu></zhishu>
        <yujing></yujing>
      </div>
      <div class="center">
        <jiankongtu>
        </jiankongtu>
      </div>
      <div class="right">
        <shengmingzhouqi></shengmingzhouqi>
        <xiyinli></xiyinli>
        <fuwu></fuwu>
      </div>
    </div>
  </div>
</template>

<script>

import top from "@/components/head/top";
import zhishu from "@/components/home/zhishu";
import yujing from "@/components/home/yujing";
import shengmingzhouqi from "@/components/home/shengmingzhouqi";
import xiyinli from "@/components/home/xiyinli";
import fuwu from "@/components/home/fuwu";
import jiankongtu from "@/components/home/jiankongtu";
export default {
  data() {
    return {
      loading: true,
      title: '政府采购得分',
      list: [{
        title: '上海',
        fenshu: 96,
        sheng: false
      }, {
        title: '大连',
        fenshu: 96,
        sheng: false
      }, {
        title: '北京',
        fenshu: 96,
        sheng: true
      }, {
        title: '深圳',
        fenshu: 96,
        sheng: false
      }]
    };
  },
  components: {
    top,
    zhishu,
    yujing,
    shengmingzhouqi,
    xiyinli,
    fuwu,
    jiankongtu
  },
  mounted() {
    this.cancelLoading();
  },
  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../main";

.banlijianzhuxuke {
  width: 3840px;
  height: 2160px;
  position: relative;
  background: url("../assets/homebg.png") no-repeat;

  .banlijianzhuxukebody {
    @include flex_between_start();
    padding-top: 250px;

    .left {
      width: 855px;
      margin-left: 140px;
    }

    .center {

    }

    .right {
      width: 820px;
      margin-right: 160px;
    }
  }
}
</style>
